import React from 'react';
import { Path } from 'svgs';
import { colors } from '@theme/tokens/colors';
import { createIllustration } from '../createIllustration';

const {
  green600,
  green700,
  white,
  yellow200,
  red600,
  purple100,
  purple600,
  grey900,
  blue200,
  blue600
} = colors;

const vectorComponent = () => (
  <>
    <Path
      fill={purple100}
      d="M1.287 138.198c-3.338-33.43 11.431-59.63 29.472-83.51C45.284 35.462 64.065 14.596 86.736 9.837c23.422-4.919 48.26 8.434 69.004 25.77 20.372 17.025 33.625 41.026 42.482 67.398 10.498 31.254 4.379 68.429-10.104 93.694H33.202c-20.262-15.942-29.37-33.015-31.915-58.501Z"
    />
    <Path
      stroke="#FF5858"
      strokeDasharray="1.53 1.53"
      strokeLinecap="round"
      strokeWidth={0.383}
      d="M124.219 96.126c.582-.026 1.199-.83 1.605-1.187 2.196-1.923 4.043-4.282 5.696-6.674 4.245-6.142 6.753-13.816 8.515-21 1.359-5.547.491-14.811-6.539-16.05-5.488-.968-8.462 4.653-9.264 9.204-.881 4.995 4.323 10.522 8.815 11.786 1.432.403 3.302-.033 4.487-.862 1.108-.777 1.748-1.657 2.344-2.875 1.507-3.081 3.055-6.157 4.346-9.337 1.697-4.182 2.204-9.719 6.237-12.457 2.047-1.39 4.762-1.952 7.14-1.533 1.906.336 2.923.88 4.292 2.226.642.632 1.124 1.374 2.061 1.54"
    />
    <Path
      fill={purple600}
      d="M161.183 70.237h-3.484a1.601 1.601 0 0 1-1.596-1.595V61.5c0-.876.719-1.595 1.596-1.595h3.484c.877 0 1.597.719 1.597 1.595v7.142c0 .876-.72 1.595-1.597 1.595Z"
    />
    <Path
      fill={grey900}
      d="M165.32 76.143a45.695 45.695 0 0 0 1.483-9.209c.09-1.706.09-3.413.54-5.053 1.349-5.031 7.081-5.817 10.948-2.942 1.641 1.235 2.832 3.054 3.282 5.053.247 1.168.269 2.403.719 3.504.607 1.55 1.911 2.628 2.788 4.02.989 1.572 1.461 3.751.944 5.57-.562 2.067-2.518 2.56-4.384 2.92-4.024.786-8.7 1.483-12.679.202-1.618-.494-4.203-1.954-3.641-4.065Z"
    />
    <Path
      fill={white}
      d="M158.531 69.159c-.472.561-.876.65-.876.65a1.108 1.108 0 0 1-1.259.99l-.45-.068a1.112 1.112 0 0 1-.944-1.19v-.023s-.315-1.662.135-3.639c.584-2.56 2.046-3.481 2.832-3.234.742.225.203 3.28.023 4.402l.809-.943a.378.378 0 0 1 .652.314l-.247 1.325a3.306 3.306 0 0 1-.675 1.416Z"
    />
    <Path fill={white} d="M155.023 69.564v2.448h2.608v-2.92h-2.608v.472Z" />
    <Path
      fill="#B78FF4"
      d="m154.732 70.236 3.35.09c.27 0-.989 12.129 2.922 10.152 1.169-.584 1.821-2.29 2.316-3.391 1.618-3.639 3.102-4.335 3.102-4.335.022 0 .719 3.638.742 3.863.247 2.358.157 4.986-1.012 7.097-1.236 2.224-3.979 3.527-6.497 3.302-3.417-.292-4.81-3.302-5.305-6.356-.539-3.392-.292-7.053.382-10.422Z"
    />
    <Path
      fill="#B78FF4"
      d="M185.844 90.451h-22.682v-9.95c0-6.266 5.08-11.342 11.352-11.342s11.352 5.076 11.352 11.342v9.95h-.022Z"
    />
    <Path
      fill={grey900}
      d="M163.162 90.563c.067 0 .112-.045.112-.112v-8.04c0-.068-.045-.113-.112-.113-.068 0-.113.045-.113.112v8.04c-.022.068.045.113.113.113ZM181.212 90.562c.068 0 .113-.045.113-.112V78.299c0-.068-.045-.113-.113-.113-.067 0-.112.045-.112.113v12.15c0 .068.045.113.112.113ZM174.043 73.134a5.961 5.961 0 0 0 4.226-1.752.108.108 0 0 0 0-.157.11.11 0 0 0-.158 0 5.729 5.729 0 0 1-8.115 0 .108.108 0 0 0-.157 0 .108.108 0 0 0 0 .157 5.871 5.871 0 0 0 4.204 1.752ZM157.228 72.73c.068 0 .112-.046.112-.113l.045-.808c0-.068-.045-.113-.112-.113s-.112.045-.112.113l-.045.808c0 .045.045.09.112.112ZM155.182 72.618c.067 0 .112-.045.112-.112l.045-.809c0-.067-.045-.112-.112-.112-.068 0-.113.045-.113.112l-.045.809c0 .067.045.112.113.112ZM155.857 72.662c.067 0 .112-.045.112-.112l.045-.809c0-.067-.045-.112-.113-.112-.067 0-.112.045-.112.112l-.045.809c0 .045.045.09.113.112ZM156.553 72.686c.067 0 .112-.044.112-.112l.045-.808c0-.068-.045-.113-.112-.113-.068 0-.113.045-.113.113l-.045.808c-.022.068.045.112.113.112Z"
    />
    <Path
      fill={white}
      d="M174.245 70.416c6.519.18 5.013-7.143 5.013-7.143l-10.409 1.123c-.022-.022.023 5.885 5.396 6.02Z"
    />
    <Path
      fill={red600}
      stroke={red600}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.766}
      d="M172.153 42.572c0 2.898-6.019 10.06-6.019 10.06s-6.018-7.162-6.018-10.06c0-2.897 2.882-5.681 6.018-5.681 3.137 0 6.019 2.784 6.019 5.681Z"
    />
    <Path
      fill="#FFF1F1"
      d="M166.134 45.379c1.389 0 2.778-1.312 2.778-2.624 0-1.311-1.389-2.623-2.778-2.623s-2.778 1.312-2.778 2.623c0 1.312 1.389 2.624 2.778 2.624Z"
    />
    <Path
      fill={green700}
      d="M28.46 76.191c-.083.115-.189.242-.32.367.069.104.145.223.225.354l.096-.72Z"
    />
    <Path
      fill={white}
      d="m47.242 39.88-.042-.007-1.17 4.873c.99.06 1.813-.083 2.183-.164-.013-.053-.017-.108-.013-.162l.727-3.1-.421-.761s-.777-.582-1.264-.68ZM40.3 47.638v-.895a5.153 5.153 0 0 1-1.934-.076v.968a31.091 31.091 0 0 1 1.934.003ZM28.35 77.017l.013-.105a9.026 9.026 0 0 0-.224-.354c-.17.163-.384.325-.645.46h.855Z"
    />
    <Path
      fill={green700}
      d="M43.943 44.283a5.18 5.18 0 0 1-1.389 1.53l2.742.658a.313.313 0 0 0 .376-.23l.359-1.497c-.34-.021-.7-.065-1.068-.145a5.081 5.081 0 0 1-1.02-.316ZM44.774 41.09c.655.048 1.283.135 1.665.184l-.813-.866c-.113-.11-.123-.291-.045-.465.076-.175.25-.306.415-.262l1.205.191.372-1.55a.313.313 0 0 0-.23-.375l-.94-.226c-.19.682-.488 1.337-.777 1.93-.248.498-.534.979-.852 1.44Z"
    />
    <Path
      fill={green700}
      d="M45.58 39.944c-.076.174-.065.357.046.466l.813.866c-.384-.05-1.01-.136-1.665-.184a7.973 7.973 0 0 1-.131.187 5.094 5.094 0 0 1-.7 3.005c.298.13.637.238 1.02.318.369.079.727.123 1.068.145l1.17-4.873-1.205-.191c-.165-.043-.338.089-.416.261Z"
    />
    <Path
      fill="#1B1C1C"
      d="M43.922 34.184c-.947.21-1.872.568-2.86.652-1.345.105-2.524-.61-3.848-.61-1.03 0-1.997.4-2.797 1.031-.125.102-.246.21-.363.322h12.44c-.324-1.098-1.344-1.67-2.572-1.395Z"
    />
    <Path
      fill="#1B1C1C"
      d="M32.022 40.64a6.88 6.88 0 0 0 1.514 3.91c.652.8 1.472 1.452 2.524 1.662.397.081.799.096 1.199.058a5.155 5.155 0 0 1-2.27-2.21 1.388 1.388 0 1 1-.628-2.659 2.031 2.031 0 0 1-.025-.173c-.146-1.241.42-2.376 1.346-3.196 1.071-.968 2.502-1.577 3.89-1.935 1.367-.357 2.65-.546 3.89.252.382.246.674.54.886.878l2.057.494c.1-.36.17-.729.192-1.098v-.526a2.605 2.605 0 0 0-.097-.519H34.058c-1.34 1.283-2.134 3.225-2.036 5.062Z"
    />
    <Path
      fill="#1B1C1C"
      d="M44.379 39.998c.119.346.203.71.245 1.083l.15.01c.318-.46.603-.941.852-1.44.289-.592.586-1.247.776-1.93l-2.057-.492c.313.497.452 1.085.44 1.751a1.567 1.567 0 0 1-.406 1.019ZM44.774 41.092c-.05-.003-.1-.008-.15-.01.008.065.014.13.019.196l.131-.186Z"
    />
    <Path
      fill={white}
      d="M40.3 46.516v.227a5.102 5.102 0 0 0 2.254-.93l-.737-.177a.313.313 0 0 1-.23-.376l.283-1.18c-1.302.979-2.948 2.037-4.614 2.191.35.173.72.307 1.108.397v-.15h1.937v-.002Z"
    />
    <Path
      fill={white}
      d="M40.3 46.743v-.227h-1.934v.15a5.117 5.117 0 0 0 1.934.077ZM43.944 44.282c-.543-.235-.949-.542-1.236-.875-.186.162-.377.32-.572.469l-.264.202-.284 1.18a.313.313 0 0 0 .23.376l.738.177a5.133 5.133 0 0 0 1.388-1.529Z"
    />
    <Path
      fill={white}
      d="M42.708 43.41c.287.33.694.638 1.236.875a5.11 5.11 0 0 0 .699-3.006 12.512 12.512 0 0 1-1.935 2.13ZM42.232 42.572c-.11-.361-.104-.711 0-.995.047-.131.157-.234.313-.31l.229-.953c-.753-.312-1.298-1.041-2.09-1.274-.947-.273-1.388.526-1.808 1.2-.525.862-1.261 1.618-2.145 2.123a2.088 2.088 0 0 1-.912.277 1.387 1.387 0 0 1-.832 1.42 5.147 5.147 0 0 0 2.269 2.21c1.664-.153 3.312-1.212 4.614-2.19l.362-1.508Z"
    />
    <Path
      fill={white}
      d="M42.233 41.578a1.57 1.57 0 0 0 0 .995l.313-1.305c-.155.076-.265.178-.313.31Z"
    />
    <Path
      fill={white}
      d="M42.708 43.41a2.333 2.333 0 0 1-.475-.837l-.362 1.507c.09-.067.179-.134.264-.201.196-.15.387-.307.573-.469ZM44.625 41.08a5.094 5.094 0 0 0-.246-1.082 1.427 1.427 0 0 1-.666.41c-.23.063-.484.063-.736-.02a1.849 1.849 0 0 1-.201-.074l-.23.953c.448-.22 1.273-.237 2.079-.186Z"
    />
    <Path
      fill={white}
      d="M44.643 41.278a4.092 4.092 0 0 0-.019-.197c-.806-.05-1.63-.035-2.078.187l-.313 1.305c.086.28.242.567.475.837.721-.629 1.375-1.348 1.935-2.132ZM34.399 41.575a2.101 2.101 0 0 1-.04-.174 1.386 1.386 0 1 0 .628 2.659 5.117 5.117 0 0 1-.591-2.39c.002-.032.003-.063.003-.095Z"
    />
    <Path
      fill={white}
      d="M35.827 42.785c0-.05-.004-.097-.008-.145-.655.03-1.217-.33-1.42-1.065 0 .032-.003.063-.003.095 0 .863.213 1.675.59 2.39.495-.213.84-.704.84-1.275Z"
    />
    <Path
      fill="#1B1C1C"
      d="M39.528 36.54c1.485 0 2.821.632 3.759 1.64l.201-.839c.04-.166.21-.27.376-.23l.483.116a2.86 2.86 0 0 0-.886-.878c-1.241-.799-2.524-.61-3.89-.252-1.389.357-2.818.966-3.891 1.935-.925.82-1.493 1.956-1.345 3.196.006.06.015.116.026.172l.044-.001a5.13 5.13 0 0 1 5.123-4.86Z"
    />
    <Path
      fill="#1B1C1C"
      d="m43.489 37.342-.202.838A5.13 5.13 0 0 1 44.38 40c.243-.265.394-.62.406-1.021.013-.664-.125-1.254-.44-1.752l-.482-.115a.313.313 0 0 0-.374.23Z"
    />
    <Path
      fill="#1B1C1C"
      d="M39.527 36.54a5.13 5.13 0 0 0-5.123 4.859l.036-.002c.717 0 1.308.546 1.38 1.244.293-.014.605-.106.911-.277.883-.505 1.62-1.261 2.146-2.124.42-.673.862-1.472 1.808-1.199.792.232 1.337.96 2.09 1.274l.513-2.135a5.116 5.116 0 0 0-3.76-1.64Z"
    />
    <Path
      fill="#1B1C1C"
      d="M43.713 40.41c.26-.073.487-.216.666-.412a5.128 5.128 0 0 0-1.092-1.818l-.513 2.134c.066.028.133.052.201.074.254.084.506.084.738.021ZM34.405 41.398l-.044.002c.01.06.024.12.04.174 0-.058.001-.117.004-.176Z"
    />
    <Path
      fill="#1B1C1C"
      d="m34.439 41.397-.035.001c-.004.058-.004.118-.005.177.203.735.765 1.095 1.42 1.064a1.387 1.387 0 0 0-1.38-1.242ZM39.36 73.993l-.443-5.567-9.466.423-.865 6.42.091.364a.345.345 0 0 1-.021.252 2.497 2.497 0 0 1-.195.306l-.098.722.062.105h10.076l.88-2.881a4.73 4.73 0 0 1-.022-.144Zm-9.779-.925c-.043 0-.105-.043-.105-.105a.1.1 0 0 1 .105-.106 3.527 3.527 0 0 0 3.534-3.533.1.1 0 0 1 .105-.106.1.1 0 0 1 .105.106 3.752 3.752 0 0 1-3.744 3.744Z"
    />
    <Path
      fill="#1B1C1C"
      d="m28.427 77.018-.062-.106-.014.106h.076ZM33.22 69.219a.1.1 0 0 0-.105.105 3.528 3.528 0 0 1-3.534 3.534.1.1 0 0 0-.105.105c0 .063.063.105.105.105a3.75 3.75 0 0 0 3.743-3.742c.001-.066-.041-.107-.104-.107Z"
    />
    <Path
      fill={white}
      d="M40.3 48.776c.423-.101.83-.269 1.205-.501.232-.145.438-.327.64-.513-.567-.06-1.188-.101-1.845-.122v1.136ZM38.366 48.791v-1.154c-.887.027-1.71.091-2.425.184.165.048.324.112.475.2a6.253 6.253 0 0 0 1.95.77Z"
    />
    <Path
      fill={white}
      d="M39.486 48.883c.277-.008.548-.044.814-.108v-1.138a30.635 30.635 0 0 0-1.934-.003v1.154c.366.075.74.109 1.12.095Z"
    />
    <Path
      fill="#1B1C1C"
      d="M40.717 68.345c.162.355.202.772.074 1.19l-1.407 4.602c.023.12.058.24.103.36l.975 2.521h10.805l-1.21-9.09-9.34.417Zm9.03 4.723a3.75 3.75 0 0 1-3.742-3.743.1.1 0 0 1 .105-.105.1.1 0 0 1 .106.105 3.528 3.528 0 0 0 3.533 3.534.1.1 0 0 1 .105.105c0 .062-.044.104-.107.104Z"
    />
    <Path
      fill="#1B1C1C"
      d="M49.747 72.857a3.528 3.528 0 0 1-3.533-3.534.1.1 0 0 0-.105-.105.1.1 0 0 0-.106.105 3.75 3.75 0 0 0 3.743 3.743.1.1 0 0 0 .105-.106c0-.062-.041-.103-.104-.103ZM39.36 73.994c.006.048.013.096.024.145l1.406-4.603a1.667 1.667 0 0 0-.073-1.19l-1.799.082.441 5.566Z"
    />
    <Path
      fill={green600}
      d="m25.544 77.02-.001-.002h-1a.315.315 0 0 0 .139.087c.24.074.47.128.685.166.096-.174.177-.25.177-.25ZM61.025 46.29c-.234-.28-.621-.6-1.12-.938v7.416c3.88-2.365 2.816-4.428 1.12-6.477ZM40.459 49.955a32.035 32.035 0 0 1-2.288 0 5.266 5.266 0 0 0 2.288 0Z"
    />
    <Path
      fill={green600}
      d="m49.187 40.203-.261 1.116.102.185c.254.01.464.135.61.327a.116.116 0 0 1-.011-.07c.006-.042.054-.077.117-.068l.98.263c.063.01.098.058.088.12-.014.083-.062.118-.138.063l-.98-.262a.069.069 0 0 1-.038-.022c.142.202.216.47.201.765l.648.175c.062.009.097.057.087.12-.01.063-.058.098-.138.063l-.62-.167-.009.055-.113.515a.901.901 0 0 1-.02.07l.599.16c.062.01.098.058.087.121-.014.083-.061.118-.138.063l-.609-.164a1.627 1.627 0 0 1-.41.591l.85.228c.063.009.098.058.087.12-.01.063-.058.098-.138.063l-.98-.263c-.003 0-.006-.003-.01-.004a1.074 1.074 0 0 1-.593.172l-.02-.009s-.075.021-.209.05c.333 1.506 6.737 3.04 5.981 3.216-.556.104-3.913-1.282-6.36-1.397-.882.106-1.766.147-2.649.19-.798.02-1.64.105-2.313.546-.261.182-.492.405-.727.623 1.897.199 3.187.59 3.187 1.039 0 .513-1.683.95-4.03 1.11a5.43 5.43 0 0 1-4.005 0c-2.35-.16-4.035-.597-4.035-1.112 0-.408 1.064-.768 2.68-.979-.733-.209-1.584-.053-2.323.032-.988.106-2.081.23-3.028.61-.295.126-.59.273-.863.462-.882.568-1.702 1.22-2.502 1.892-2.544 2.187-4.71 4.858-6.161 7.886-3.07 6.456 2.713 16.99 3.406 18.232.023.03.046.058.07.081h1a1.044 1.044 0 0 1 .279-1.202l-.257-.626c-.021-.042 0-.105.063-.126.042-.022.105 0 .126.062l.046.112a.105.105 0 0 1 .073.062l.132.393a.562.562 0 0 1 .087-.04l.378-.146c.046-.017.092-.03.138-.04l-.241-.591c-.022-.043 0-.105.062-.127.043-.021.106 0 .127.063l.066.16a.12.12 0 0 1 .055.058l.135.408.002.003a.997.997 0 0 1 .94.59l.022.022s.151.18.367.504c.13-.127.238-.253.32-.366l.124-.921c-.463-1.854-2.042-8.507-1.906-10.677.127-1.808 2.46-4.879 3.807-6.497.157-.2.42-.158.546.001l1.263-5.343c.022-.063.063-.105.127-.084.063.021.105.063.084.127l-2.817 11.839a.172.172 0 0 1-.023.035l-.86 3.772c-.062.21.127.42.358.42l.29-.014.004-.03c.127-.84.841-1.471 1.683-1.471h7.882c.25-.62.841-1.07 1.559-1.115l7.443-.61a1.807 1.807 0 0 1 1.935 1.557l.1.748.279-.012c.21 0 .357-.19.335-.4l-.885-6.54c-.063-.002-.104-.043-.104-.085l-1.199-8.642c-.021-.063.022-.127.084-.127.063-.022.127.021.127.084l.428 3.087a.33.33 0 0 1 .181-.122c1.304-.4 6.77-.084 10.556-2.376l.044-.027v-7.417c-3.126-2.132-10.57-5.122-10.714-5.14Zm-23.864 36.48c-.058.026-.113.005-.128-.08l-.188-.566-.219-.532c-.02-.043 0-.106.063-.127.043-.022.105 0 .127.063l.037.091c.015.01.029.026.04.047l.088.268.212.519c.012.026.008.058-.01.085l.03.09c.026.062.004.117-.052.142Zm1.904-2.249c.043-.021.105 0 .127.063l.08.194a.11.11 0 0 1 .06.06l.163.49.074.18a.09.09 0 0 1 .004.053l.08.24c.026.058.004.113-.052.139-.077.035-.133.014-.128-.08l-.115-.342-.356-.872c-.021-.04-.001-.103.063-.125Z"
    />
    <Path
      fill={green600}
      d="M48.213 44.582c.134-.029.209-.05.209-.05l.02.009c.206.006.41-.058.592-.173-.036-.012-.065-.056-.056-.113.006-.04.055-.076.117-.067l.132.035c.17-.154.313-.357.409-.59l-.371-.1c-.041-.006-.077-.055-.067-.117.006-.042.055-.077.117-.068l.382.103.02-.07.113-.515.009-.055-.36-.096c-.042-.007-.077-.055-.068-.118.007-.041.055-.076.118-.067l.333.088a1.224 1.224 0 0 0-.22-.79.789.789 0 0 0-.61-.326l-.101-.185-.727 3.102a.453.453 0 0 0 .009.163ZM27.496 77.018h-1.953l.001.003s-.08.076-.175.25c.927.16 1.618.008 2.127-.253Z"
    />
    <Path
      fill={green600}
      d="M28.14 76.558c-.215-.325-.367-.504-.367-.504l-.02-.022a1 1 0 0 0-.942-.59l.121.296c.01.02.01.046 0 .069l.063.187c.026.058.004.113-.052.14-.058.025-.113.004-.128-.082l-.142-.423-.068-.163c-.045.01-.091.023-.137.04l-.379.146c-.03.013-.06.026-.087.04l.08.237.05.123a.086.086 0 0 1 .006.045l.055.166c.026.058.005.113-.052.14-.076.034-.133.013-.128-.08l-.067-.202-.002-.006-.122-.3a1.042 1.042 0 0 0-.278 1.203h1.953c.26-.135.473-.297.643-.46ZM24.934 75.522c.024-.011.055-.005.08.013l-.036-.091c-.022-.063-.084-.084-.127-.063-.062.022-.084.084-.062.127l.218.533-.133-.399c-.018-.04.002-.094.06-.12ZM25.355 76.369l-.212-.52.201.605c.019-.027.025-.06.011-.085ZM27.731 75.422l-.073-.18.078.234a.092.092 0 0 0-.005-.054ZM27.52 75.433l-.207-.622c-.017-.038.003-.094.06-.12a.077.077 0 0 1 .059.001l-.08-.194c-.021-.062-.084-.084-.126-.062-.063.021-.084.084-.063.126l.357.87ZM26.812 75.443l-.002-.003.002.003Z"
    />
    <Path
      fill={green600}
      d="M26.492 75.09c-.016-.038.004-.095.062-.12a.077.077 0 0 1 .065.002l-.065-.16c-.022-.063-.084-.084-.127-.063-.063.022-.084.084-.063.127l.241.59c.005 0 .008 0 .011-.002l-.123-.374ZM26.618 75.465c-.003.001-.008.001-.011.003l.067.163-.056-.166ZM26.932 75.807a.089.089 0 0 0 0-.068l-.12-.297.12.365ZM25.692 75.36c-.016-.037.003-.094.061-.12a.071.071 0 0 1 .048-.001l-.046-.112c-.021-.062-.084-.084-.127-.062-.062.021-.084.084-.062.126l.256.626.018-.013-.148-.443Z"
    />
    <Path
      fill={green600}
      d="m25.946 76.12-.107-.318-.018.013.122.3.003.006ZM26.134 76.054l-.05-.123.056.167a.084.084 0 0 0-.006-.044ZM28.678 75.633a23.02 23.02 0 0 1-.092-.364l-.124.921c.089-.122.155-.229.196-.305a.352.352 0 0 0 .02-.252ZM38.897 68.168a1.77 1.77 0 0 1 .124-.82h-7.882c-.841 0-1.556.63-1.683 1.472l-.004.029 9.465-.423-.02-.258ZM40.3 48.776v.306h-1.934v-.29a6.267 6.267 0 0 1-1.95-.77 1.986 1.986 0 0 0-.475-.2c-1.616.211-2.68.572-2.68.98 0 .513 1.686.95 4.036 1.111a5.3 5.3 0 0 1-1.828-1.217.1.1 0 0 1 0-.146.1.1 0 0 1 .147 0 5.192 5.192 0 0 0 2.556 1.409 29.927 29.927 0 0 0 2.287 0 5.231 5.231 0 0 0 2.56-1.408.1.1 0 0 1 .146 0 .1.1 0 0 1 0 .147 5.59 5.59 0 0 1-1.865 1.215c2.347-.162 4.03-.597 4.03-1.11 0-.449-1.29-.84-3.187-1.038a4.375 4.375 0 0 1-.64.513c-.374.229-.78.397-1.203.498Z"
    />
    <Path
      fill={green600}
      d="M38.365 48.79v.29H40.3v-.307a4.05 4.05 0 0 1-.814.109 4.735 4.735 0 0 1-1.12-.092ZM40.717 68.344l9.34-.417-.1-.748a1.807 1.807 0 0 0-1.934-1.556l-7.443.61a1.79 1.79 0 0 0-1.56 1.114h.15c.703 0 1.285.42 1.547.997Z"
    />
    <Path
      fill={green600}
      d="m38.897 68.168.02.258 1.799-.081a1.69 1.69 0 0 0-1.547-.997h-.15c-.1.25-.146.53-.122.82Z"
    />
    <Path
      fill="#1B1C1C"
      d="M29.584 64.72c.03 0 .06-.022.082-.05l1.432-6.28a.333.333 0 0 0-.064-.293L29.5 64.593c-.022.062.021.105.084.126Z"
    />
    <Path
      fill="#1B1C1C"
      d="m31.096 58.388-1.432 6.28a.176.176 0 0 0 .023-.035l2.817-11.839c.022-.062-.021-.105-.084-.126-.063-.022-.105.021-.127.084l-1.262 5.343a.33.33 0 0 1 .065.293ZM49.895 60.85l-.77-5.556a.348.348 0 0 0-.07.257l.734 5.425h.001c.063-.002.105-.064.105-.127Z"
    />
    <Path
      fill="#1B1C1C"
      d="m49.124 55.293-.427-3.087c0-.063-.063-.106-.127-.084-.062 0-.105.062-.084.127l1.199 8.642c0 .042.041.083.104.084l-.735-5.425a.35.35 0 0 1 .07-.257ZM39.317 50.082c-.39 0-.774-.044-1.145-.125-.3-.01-.593-.026-.877-.046.628.25 1.304.382 2 .382a5.46 5.46 0 0 0 2.005-.382c-.271.018-.554.034-.842.044a5.24 5.24 0 0 1-1.141.127Z"
    />
    <Path
      fill="#1B1C1C"
      d="M35.617 48.547a.1.1 0 0 0-.146 0 .1.1 0 0 0 0 .146 5.305 5.305 0 0 0 1.828 1.217c.282.02.575.036.876.046a5.178 5.178 0 0 1-2.558-1.41ZM43.167 48.547a.1.1 0 0 0-.147 0 5.224 5.224 0 0 1-2.56 1.408c.29-.011.57-.026.844-.045a5.601 5.601 0 0 0 1.864-1.215.106.106 0 0 0-.001-.148ZM49.044 44.373l.98.262c.08.034.128-.001.137-.062.01-.063-.024-.11-.087-.12l-.849-.228a1.536 1.536 0 0 1-.19.145l.009.003Z"
    />
    <Path
      fill="#1B1C1C"
      d="M48.976 44.255c-.01.057.02.101.057.113.067-.041.13-.09.19-.145l-.13-.035c-.062-.01-.11.026-.117.067ZM49.695 41.878l.98.263c.077.055.126.02.138-.063.01-.062-.025-.11-.087-.12l-.98-.263c-.063-.01-.11.024-.118.067a.117.117 0 0 0 .01.07l.019.025c.01.01.023.02.038.021Z"
    />
    <Path
      fill="#1B1C1C"
      d="M49.639 41.832c.005.01.01.019.019.025l-.02-.025ZM50.458 42.978c.079.034.128-.001.137-.062.01-.063-.024-.11-.087-.12l-.648-.175c-.002.063-.01.127-.022.191l.62.166Z"
    />
    <Path
      fill="#1B1C1C"
      d="M49.41 42.6c-.01.063.024.11.067.118l.36.097c.013-.064.02-.129.023-.191l-.332-.089c-.063-.01-.112.025-.118.066ZM50.242 43.797c.076.055.125.02.138-.063.009-.063-.025-.11-.088-.12l-.598-.16a1.783 1.783 0 0 1-.061.18l.609.163Z"
    />
    <Path
      fill="#1B1C1C"
      d="M49.195 43.417c-.01.063.024.11.067.118l.37.099c.025-.058.045-.12.062-.18l-.382-.102c-.062-.011-.111.024-.117.065ZM25.344 76.454a.11.11 0 0 1-.052.041h-.042c-.043 0-.084-.021-.084-.063l-.16-.392.187.565c.015.085.072.107.128.081.057-.026.078-.083.052-.139l-.029-.093ZM25.053 75.582a.121.121 0 0 0-.04-.047l.128.315-.088-.267Z"
    />
    <Path
      fill="#1B1C1C"
      d="M25.25 76.496h.042a.09.09 0 0 0 .052-.041l-.201-.605-.128-.314c-.027-.019-.057-.025-.082-.014-.058.026-.077.082-.06.12l.132.399.16.392c0 .042.043.063.085.063ZM27.494 74.752a.105.105 0 0 0-.06-.06l.224.55-.164-.49ZM27.668 75.549h-.042c-.043 0-.084-.043-.084-.063l-.022-.053.115.342c-.003.094.052.114.128.08.058-.027.078-.083.052-.14l-.08-.24a.098.098 0 0 1-.067.074Z"
    />
    <Path
      fill="#1B1C1C"
      d="M27.373 74.69c-.058.026-.077.083-.06.121l.207.622.021.053c0 .021.043.063.084.063h.043a.097.097 0 0 0 .067-.074l-.078-.233-.224-.55a.08.08 0 0 0-.06-.001ZM26.674 75.032a.12.12 0 0 0-.055-.058l.191.465-.136-.407ZM26.87 75.865h-.043c-.043 0-.084-.042-.084-.062l-.07-.171.142.423c.015.085.071.107.128.08.058-.025.078-.082.052-.138l-.063-.188a.106.106 0 0 1-.062.056Z"
    />
    <Path
      fill="#1B1C1C"
      d="M26.554 74.97c-.058.026-.078.082-.061.12l.125.375c.064-.014.128-.022.194-.023l-.002-.003-.19-.466a.076.076 0 0 0-.066-.003Z"
    />
    <Path
      fill="#1B1C1C"
      d="m26.618 75.465.055.165.07.17c0 .022.043.063.084.063h.043a.106.106 0 0 0 .064-.058l-.122-.365c-.064.004-.13.011-.194.025ZM26.004 75.693l-.132-.392a.105.105 0 0 0-.073-.063l.19.463a.049.049 0 0 0 .015-.008Z"
    />
    <Path
      fill="#1B1C1C"
      d="m26.083 75.93-.08-.237-.015.008.095.229ZM26.07 76.18h-.043c-.04 0-.077-.035-.083-.058l.068.202c-.003.094.051.114.128.08.058-.027.078-.083.052-.14l-.055-.166a.091.091 0 0 1-.067.082Z"
    />
    <Path
      fill="#1B1C1C"
      d="M25.754 75.241c-.058.026-.078.083-.062.12l.147.442a.916.916 0 0 1 .15-.1l-.19-.463a.067.067 0 0 0-.045.001Z"
    />
    <Path
      fill="#1B1C1C"
      d="m25.84 75.802.106.32a.098.098 0 0 0 .082.058h.043a.097.097 0 0 0 .069-.081l-.057-.168-.093-.228a.917.917 0 0 0-.15.1Z"
    />
    <Path
      stroke="#FF5858"
      strokeDasharray="1.53 1.53"
      strokeLinecap="round"
      strokeWidth={0.383}
      d="M90.175 92.05c1.54 1.386 3.645 2.37 5.264 1.259 1.212-.831 1.778-1.618 2.192-4.539 1.14-8.047-1.078-14.317-2.601-20.971-1.129-4.929-2.227-11.253-.178-15.645 1.543-3.31 3.645-5.045 5.726-5.044M82.17 101.591c-3.107 1.181-7.353 2.019-10.618 1.071-2.443-.709-3.583-1.38-4.415-3.87-2.291-6.862 2.187-12.206 5.265-17.878 2.28-4.202 4.5-9.593.373-13.338-3.11-2.822-7.346-4.303-11.544-4.303"
    />
    <Path
      fill="#1B1C1C"
      d="M95.104 13.554v-.9A4.584 4.584 0 1 0 89.64 7.81a.984.984 0 1 0 .276 1.95 4.594 4.594 0 0 0 3.249 2.861v.68a42.834 42.834 0 0 0-2.525-.175c-1.516-.128-2.687-.125-3.12.044-1.193.155-3.282.984-6.263 4.18-2.552-1.924-6.177-5.51-5.36-9.947 1.128-6.137 6.352-5.496 7.326-5.199 3.04.929 3.87 1.676 7.403-.268a7.408 7.408 0 0 1 10.162 10.401 5.865 5.865 0 0 1-1.31 1.445c-.302.255-.624.485-.965.69-.016-.004-.03-.01-.047-.014.001.003-.931-.503-3.362-.903Z"
    />
    <Path
      fill={white}
      d="M93.165 12.62a4.599 4.599 0 0 0 1.941.033v.9a31.36 31.36 0 0 0-1.94-.254v-.679h-.001Z"
    />
    <Path
      fill={white}
      d="M93.165 11.14v1.482a4.594 4.594 0 0 1-3.25-2.861.984.984 0 1 1-.275-1.95 4.584 4.584 0 1 1 5.465 4.845V11.14h-1.94Z"
    />
    <Path
      fill={white}
      d="M93.164 12.62v-1.482h1.94v1.515a4.612 4.612 0 0 1-1.94-.032ZM114.949 31.11c.042-.099.174-.348.521-.63.333-.266.732-.429 1.129-.53l1.064-.171c.133-.034.263.052.321.172.041.115-.004.24-.095.33l-.764.637c.907-.125 3.347-.5 3.517.103.183.626-.584 1.786-2.633 2.196-1.593.307-2.902.03-2.902.03l-.025.013a.885.885 0 0 1-.248-.016l.479-2.027c-.122-.038-.243-.072-.364-.107Z"
    />
    <Path
      fill={white}
      d="M112.492 30.475c.812.188 1.64.4 2.457.635a.657.657 0 0 0-.017.046c-.51.024-.87.48-.824.98l.036.354c.049.38.328.677.689.753l-.001.005s-1.679-.236-3.667-.44v-.029l1.327-2.304Z"
    />
    <Path
      fill={white}
      d="M111.165 32.777v.03l-.017-.001.017-.029ZM114.144 32.488l-.036-.355c-.046-.499.314-.956.824-.979 0 0 .005-.016.018-.046l.362.106-.479 2.027a.878.878 0 0 1-.689-.753Z"
    />
    <Path
      fill="#016938"
      d="M102.598 20.135c.019.028.036.057.052.086l-.042-.012-.01-.074Z"
    />
    <Path
      fill="#FB3"
      d="M98.288 18.884s-.743.716-.35 2.82l-4.551 7.928c-.148-.05-.25-.077-.25-.077s.591-.382-.345-.596c-.86-.197-1.15.124-1.536.421l-5.789-1.683a.848.848 0 0 0-.323-.029 43.332 43.332 0 0 1-2.382-1.297c.162-1.441.366-2.802.62-3.985.54.38.829.38.829.38s1.657-1.259 2.645-2.719c1.074-1.175 2.15-2.47 2.523-3.303a3.03 3.03 0 0 0 .14-.381c.004.01.01.02.017.03a6.1 6.1 0 0 0 4.129 2.324 6.268 6.268 0 0 0 4.577-1.285c.057-.044.065-.112.02-.17a.116.116 0 0 0-.17-.02c-2.576 2.024-6.34 1.574-8.365-1.001a.115.115 0 0 0-.17-.02h-.002c.385-1.631-.851-2.962-.851-2.962s-.035-.017-.103-.038l.794.082a7.44 7.44 0 0 0 1.905 1.409c.543.885 1.493 1.838 3.094 1.998 2.82.28 3.88-1.818 4.047-2.195l.072-.045c2.99.818 3.842 3.948 4.084 5.663-.843-1.264-4.309-1.249-4.309-1.249ZM89.665 32.004c3.634 1.687 4.179.608 4.59-.019a1.94 1.94 0 0 0 .287-.768l3.257.946a119.077 119.077 0 0 0-.605 4.476H82.171c.037-1.975.116-4.324.276-6.672 3.024.9 6.188 1.76 7.218 2.037Z"
    />
    <Path
      fill="#FB3"
      d="M87.52 13.17c.431-.17 1.603-.174 3.12-.046 0 .006.155.768.66 1.59a7.439 7.439 0 0 1-1.904-1.408l-.794-.083c-.164-.051-.525-.126-1.083-.054Z"
    />
    <Path fill="#10A44A" d="m98.466 14.459.048.014-.072.045.025-.059Z" />
    <Path
      fill="#FB3"
      d="M99.846 19.405a.67.67 0 0 0-.766.31l-1.143 1.99c-.391-2.104.351-2.82.351-2.82s3.466-.015 4.311 1.25c.004.024.006.048.009.073l-2.762-.803Z"
    />
    <Path
      fill={white}
      d="M90.64 13.125c.937.04 1.776.102 2.525.176v.114a45.278 45.278 0 0 0-2.526-.29ZM95.104 13.554c2.43.4 3.363.904 3.363.904a44.047 44.047 0 0 0-3.363-.732v-.172Z"
    />
    <Path
      fill={white}
      d="M93.164 13.416v-.115c.732.073 1.376.161 1.94.253v.174a51.205 51.205 0 0 0-1.94-.312ZM93.165 15.884h1.94v-.36a7.37 7.37 0 0 0 3.338-1.005c-.167.376-1.23 2.475-4.048 2.194-1.6-.158-2.55-1.113-3.094-1.998.58.3 1.206.525 1.864.663v.506Z"
    />
    <Path
      fill={white}
      d="M93.165 13.416v1.963a7.385 7.385 0 0 1-1.864-.663c-.506-.823-.66-1.585-.662-1.59.77.064 1.63.161 2.526.29ZM95.104 13.727c1.153.208 2.307.455 3.363.732l-.024.059a7.364 7.364 0 0 1-3.339 1.006v-1.796Z"
    />
    <Path
      fill={white}
      d="M95.104 15.523v.36h-1.94v-.506a7.469 7.469 0 0 0 1.94.146Z"
    />
    <Path
      fill={white}
      d="M95.104 15.523a7.363 7.363 0 0 1-1.94-.146v-1.963c.635.09 1.287.195 1.94.312v1.797Z"
    />
    <Path
      fill="#7FC1F4"
      d="M108.732 35.343c.095.027.192.04.287.042l-.011.038-11.21-3.259 10.934 3.179Z"
    />
    <Path
      fill="#FB3"
      d="M90.265 29.615c-1.661-.357-3.49-1.127-5.12-1.945a.848.848 0 0 1 .324.028l5.789 1.684-.106.08c-.292.206-.664.188-.887.153Z"
    />
    <Path
      fill="#7FC1F4"
      d="m111.165 22.695 4.403 1.28a.466.466 0 0 1 .273.682l-3.35 5.816a61.254 61.254 0 0 0-1.327-.292v-7.486h.001Z"
    />
    <Path
      fill="#7FC1F4"
      d="m104.972 29.169-1.474-4.002c.427-.294.504-.508.504-.508s-.434-2.303-1.303-4.342c-.013-.032-.03-.065-.047-.097l8.515 2.475v7.485a71.166 71.166 0 0 0-6.195-1.011Zm.704-2.777c-.346-.151-.801.134-1.019.634-.217.5-.113 1.027.233 1.178.345.15.801-.134 1.019-.634.216-.5.112-1.028-.233-1.178Z"
    />
    <Path
      fill="#7FC1F4"
      d="M97.929 31.321c.382-2.413.796-4.67 1.132-6.406.355.742.805 1.564 1.37 2.48 0 0 .092.035.232.002.435.965 1.178 2.586 1.601 3.354.623 1.133 2.284 1.819 3.875 1.763 1.294-.046 3.271.11 5.011.29l-1.174 2.038a1.09 1.09 0 0 1-.957.543l.225-.775-11.315-3.289ZM111.165 30.18c.434.091.878.19 1.327.294l-1.327 2.302v-2.595Z"
    />
    <Path
      fill="#7FC1F4"
      d="M106.138 32.513c-1.593.056-3.253-.63-3.876-1.763-.423-.769-1.165-2.389-1.6-3.354.727-1.015 2.537-2.316 2.727-2.452l.019-.01.082.235.006-.004 1.475 4.002s2.801.302 6.193 1.012v2.596l-.017.027c-1.739-.177-3.714-.333-5.009-.289Z"
    />
    <Path
      fill="#7FC1F4"
      d="M103.39 24.945c-.189.136-1.999 1.437-2.727 2.453l-.093-.208c.303-.419 1.146-1.399 2.82-2.245Z"
    />
    <Path
      fill="#7FC1F4"
      d="M104 24.658c-.205.044-.563.255-.591.273l-.072-.194c-2.037.499-3.02 1.89-3.02 1.89l.242.54-.129.227a26.927 26.927 0 0 1-1.37-2.48c.397-2.052.685-3.379.685-3.379 1.737-.515 2.95-.263 2.95-.263s0-.424-.087-1.064l.042.012a.69.69 0 0 1 .047.098c.869 2.038 1.303 4.34 1.303 4.34Z"
    />
    <Path
      fill="#7FC1F4"
      d="m100.559 27.168-.242-.541s.984-1.39 3.02-1.89l.072.194c-.001.002-.003.002-.003.002-2.048 1.019-2.847 2.235-2.847 2.235Z"
    />
    <Path
      fill="#7FC1F4"
      d="M103.408 24.936c-.007.002-.013.007-.02.01a.23.23 0 0 1 .018-.013l.002.003Z"
    />
    <Path
      fill="#7FC1F4"
      d="m100.568 27.188-.01-.02s.8-1.216 2.848-2.235l-.017.012c-1.673.846-2.516 1.826-2.821 2.243ZM104 24.658s-.077.213-.504.508l-.086-.231c.187-.095.383-.187.59-.277Z"
    />
    <Path
      fill="#7FC1F4"
      d="m103.407 24.936.003-.001.086.231-.006.004-.083-.234ZM103.41 24.93c.029-.016.387-.227.591-.272-.207.09-.402.182-.589.275l-.002-.002Z"
    />
    <Path
      fill="#7FC1F4"
      d="m103.406 24.936-.002-.003.004-.002.002.003c0 .002-.002.002-.004.002ZM100.662 27.397a.43.43 0 0 1-.232-.003s.044-.076.139-.204l.093.207ZM100.569 27.189l.093.207-.093-.207Z"
    />
    <Path
      fill="#7FC1F4"
      d="m100.431 27.394.129-.226.01.02c-.095.13-.139.206-.139.206ZM100.568 27.189l-.009-.021.009.021ZM94.439 30.306a.71.71 0 0 0-.144-.203c-.23-.217-.642-.381-.908-.47l4.55-7.928c.156.836.491 1.892 1.124 3.21-.336 1.736-.75 3.993-1.132 6.406l-3.49-1.015Z"
    />
    <Path
      fill="#7FC1F4"
      d="M99.08 19.714a.668.668 0 0 1 .766-.31l2.762.805a9.26 9.26 0 0 1 .087 1.064s-1.212-.252-2.95.263c0 0-.288 1.327-.686 3.38-.632-1.319-.967-2.375-1.123-3.21l1.144-1.992ZM108.732 35.343l-10.933-3.179c.044-.283.087-.564.132-.843l11.314 3.289-.225.775a1.103 1.103 0 0 1-.288-.042ZM94.439 30.306l3.49 1.014-.131.843-3.257-.946c.053-.34.014-.674-.102-.911Z"
    />
    <Path
      fill={blue200}
      d="M105.907 27.569c-.217.5-.673.785-1.019.634-.346-.15-.45-.676-.233-1.178.217-.5.674-.785 1.019-.634.347.15.45.678.233 1.178Z"
    />
    <Path
      fill={white}
      d="M79.616 19.71c.626.183 2.13.75 3.848 2.319-.024.106-.049.211-.072.32l-.028.023-3.026 2.482s.974.67 2.425 1.518a81.82 81.82 0 0 0-.318 3.595c-2.441-.725-4.793-1.476-5.862-1.967-2.683-1.23-1.651-3.392-.55-4.652.747-.854 2.39-2.475 3.372-3.432l.211-.205Z"
    />
    <Path
      fill={white}
      d="M85.146 27.67a.844.844 0 0 0-.726.606l5.6 1.628-.355 2.102a315.364 315.364 0 0 1-7.219-2.037c.083-1.216.187-2.432.319-3.595.699.408 1.512.86 2.381 1.296ZM83.392 22.35c.023-.11.047-.216.072-.32.05.044.099.091.149.139l-.221.18Z"
    />
    <Path
      fill={white}
      d="m90.076 29.571-.056.33-5.6-1.627a.846.846 0 0 1 .726-.606c1.63.819 3.458 1.589 5.12 1.945-.116-.017-.19-.042-.19-.042ZM91.257 29.382c.384-.297.677-.618 1.536-.421.937.214.344.596.344.596s.103.027.251.078l-.18.315-1.95-.568ZM90.366 30.003l4.176 1.215c-.04.267-.134.538-.286.768-.41.625-.957 1.704-4.59.02l.346.093.354-2.096Z"
    />
    <Path
      fill={white}
      d="M90.426 29.647a6.308 6.308 0 0 1-.159-.034c.223.037.595.054.885-.153.037-.026.072-.053.106-.08l1.95.567-.435.755 1.77.513-4.177-1.214.06-.354Z"
    />
    <Path
      fill={white}
      d="m94.439 30.306-1.232-.357.18-.316c.266.09.677.252.908.47a.71.71 0 0 1 .144.203Z"
    />
    <Path
      fill={white}
      d="m94.542 31.217-1.769-.514.434-.755 1.232.358c.117.237.155.57.103.911ZM90.366 30.003l-.354 2.094-.347-.093.355-2.103.346.102Z"
    />
    <Path
      fill={white}
      d="m90.265 29.614.159.034-.06.357-.346-.1.056-.332c.002-.002.076.022.191.041Z"
    />
    <Path
      fill="#FB3"
      d="M84.927 17.247A59.514 59.514 0 0 0 83.7 21.11c-.047.169-.094.34-.14.52-1.48-1.954-3.371-2.472-3.371-2.472s-.215.206-.55.533l-.333-.055a36.903 36.903 0 0 1 1.952-2.286c1.31.987 2.337 1.536 2.337 1.536l1.334-1.639Z"
    />
    <Path
      fill="#FB3"
      d="M87.52 13.169c-.017.007-.032.012-.045.019-.719.346-1.463 1.076-2.547 4.057l-1.334 1.639s-1.027-.55-2.337-1.536c2.98-3.195 5.07-4.024 6.262-4.18ZM83.866 22.385c-.134-.125-.25-.22-.25-.22l.206-.17a8.862 8.862 0 0 0-.262-.367c.045-.179.09-.35.14-.519a59.576 59.576 0 0 1 1.228-3.863l3.306-4.061.367.037a1 1 0 0 1 .103.039s1.236 1.33.851 2.963c-.046.038-.06.09-.038.14a2.81 2.81 0 0 1-.14.38c-.372.834-1.448 2.128-2.522 3.304.003.001-2.158 1.827-2.989 2.337Z"
    />
    <Path
      fill="#FB3"
      d="M84.927 17.247c1.085-2.98 1.829-3.712 2.547-4.057l.045-.019c.557-.071.919.003 1.083.055l-.367-.038-3.308 4.06ZM79.616 19.711l.021-.02.55-.533s1.892.518 3.373 2.471l-.097.4c-1.715-1.57-3.22-2.136-3.847-2.318ZM83.617 22.166l-.003.002-.149-.14c.031-.135.064-.269.098-.4.09.119.176.24.261.368l-.207.17Z"
    />
    <Path
      fill="#E39D21"
      d="M83.867 22.384c.83-.51 2.99-2.337 2.99-2.337-1.325 1.449-2.646 2.718-2.646 2.718a2.226 2.226 0 0 0-.344-.381Z"
    />
    <Path
      fill="#016938"
      d="m83.392 22.349-.008.039a.182.182 0 0 0-.022-.014l.03-.025Z"
    />
    <Path
      fill="#E39D21"
      d="M86.858 20.048c-.989 1.46-2.646 2.718-2.646 2.718s1.321-1.27 2.646-2.718ZM83.613 22.168c.1.095.202.192.302.294l.295.304s-.288.001-.828-.38l.008-.038.223-.18Z"
    />
    <Path
      fill="#E39D21"
      d="m83.866 22.385-.016.01.065.067c-.102-.102-.202-.2-.302-.294l.002-.003c.002.001.118.096.251.22Z"
    />
    <Path
      fill="#016938"
      d="m84.212 22.767-.296-.304c.098.098.197.198.296.303Z"
    />
    <Path
      fill="#E39D21"
      d="m83.916 22.462-.064-.068.016-.01c.127.12.272.265.345.382-.1-.105-.199-.205-.296-.304ZM79.404 19.917c-.101-.154-.099-.283-.099-.283s.111.019.31.077c-.064.065-.136.134-.21.206Z"
    />
    <Path
      fill="#016938"
      d="m79.616 19.71-.212.207c.075-.072.147-.141.212-.206Z"
    />
    <Path fill="#016938" d="m79.615 19.712.023-.022-.023.021Z" />
    <Path
      fill="#1B1C1C"
      d="M89.558 16.223a.115.115 0 0 1 .17.02c2.026 2.576 5.79 3.026 8.365 1a.115.115 0 0 1 .171.021c.045.057.037.125-.02.17a6.273 6.273 0 0 1-4.578 1.286 6.104 6.104 0 0 1-4.128-2.325.11.11 0 0 1-.018-.03l.038-.142c-.001 0-.001 0 0 0Z"
    />
    <Path
      fill="#1B1C1C"
      d="M89.557 16.225c-.011.046-.025.092-.038.139a.112.112 0 0 1 .038-.14Z"
    />
    <Path
      fill={red600}
      stroke={red600}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.766}
      d="M112.659 42.163c0 2.898-6.019 10.06-6.019 10.06s-6.018-7.162-6.018-10.06c0-2.897 2.882-5.682 6.018-5.682 3.137 0 6.019 2.785 6.019 5.682Z"
    />
    <Path
      fill="#FFF1F1"
      d="M106.64 44.97c1.389 0 2.778-1.312 2.778-2.624s-1.389-2.623-2.778-2.623-2.777 1.311-2.777 2.623c0 1.312 1.388 2.623 2.777 2.623Z"
    />
    <Path
      fill={red600}
      stroke={red600}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.766}
      d="M67.136 61.631c0 2.898-6.018 10.059-6.018 10.059s-6.019-7.161-6.019-10.059c0-2.898 2.883-5.682 6.019-5.682s6.018 2.784 6.018 5.682Z"
    />
    <Path
      fill="#FFF1F1"
      d="M61.118 64.437c1.389 0 2.778-1.311 2.778-2.623 0-1.312-1.39-2.624-2.778-2.624-1.389 0-2.778 1.312-2.778 2.624s1.389 2.623 2.778 2.623Z"
    />
    <Path
      fill="#1D7F1C"
      d="M171.505 165.866h-.663c0-.661-.02-16.287-1.755-23.568-1.722-7.228-7.367-12.849-7.424-12.905l.498-.378c.057.057 5.818 5.786 7.576 13.169 1.747 7.335 1.768 23.018 1.768 23.682Z"
    />
    <Path
      fill="#1D7F1C"
      d="M169.586 165.904c-2.142-14.357-6.683-18.712-6.728-18.755l.484-.393c.193.176 4.728 4.49 6.903 19.074l-.659.074ZM172.202 166.835l-.661-.052c.004-.036.384-3.679.023-9.742-.364-6.147 3.318-15.168 3.355-15.258l.627.193c-.038.09-3.674 9.005-3.316 15.036.36 6.108-.024 9.788-.028 9.823Z"
    />
    <Path
      fill="#1D7F1C"
      d="M174.707 144.229s-5.883-9.097-6.722-18.84c-.839-9.744.167-14.021 5.954-21.703 5.785-7.682 5.617-13.044 5.617-13.044s2.936 4.42 4.36 10.58c1.427 6.16-1.326 33.846-9.209 43.007Z"
    />
    <Path
      fill="#14A34A"
      d="M162.926 130.322c-.232 0-7.416-3.517-10.108-7.157-2.317-3.134-6.119-11.403-7.916-16.644 1.591 1.131 3.394 2.307 4.197 2.454 0 0-2.561-1.834-4.577-3.614a26.112 26.112 0 0 1-.322-1.112c-1.231-4.706-2.075-7.815-3.306-10.123 0 0 7.665 5.138 9.838 6.472.406 2.222.965 5.486.965 6.637 0 0 .325-3.214.393-5.637 2.245 1.892 6.32 6.021 8.633 9.609-.035 2.352-.162 6.84-.612 8.927 0 0 1.336-3.068 1.934-6.447.092.236.171.466.233.686 2.002 7.105.648 15.949.648 15.949ZM165.475 150.315s-5.159-.914-8.071-1.944c-2.91-1.03-6.72-2.744-9.181-10.405-2.461-7.661-3.916-12.577-3.916-12.577s5.424 4.002 8.598 5.488c3.174 1.487 13.097 6.288 13.759 10.862.663 4.574-1.189 8.576-1.189 8.576ZM185.615 117.88c.309-.159 3.989-2.053 6.345-3.453a51.303 51.303 0 0 1-.821 3.987c-.407 1.624-1.189 3.498-2.201 5.471v.003c-1.451 1.117-4.58 4.138-6.765 5.31.25-.103 2.965-1.232 5.092-2.305-4.145 6.99-10.144 14.234-12.034 15.559 0 0 0 .003-.004.006-.146.1-.266.167-.359.196 0 0-.275-.58-.661-1.59-1.355-3.57-4.068-12.502-.664-19.904.431-.936.967-1.906 1.587-2.899.349 2.244 1 5.324 2.079 7.13 0 0-.624-5.856-.6-9.34v-.008c2.181-3.031 4.9-6.131 7.521-8.875.585-.612 1.162-1.206 1.723-1.774l-.258 4.308 1.494-5.54c3.464-3.418 6.173-5.758 6.173-5.758s-.004 6.797-.963 13.781c-1.766 1.682-4.702 4.386-6.684 5.695Z"
    />
    <Path
      fill="#1D7F1C"
      d="M171.897 156.032s8.395-13.72 13.818-15.664c5.424-1.944 8.732-4.574 8.732-4.574s-.384 1.83-1.185 6.061c-.8 4.23-7.14 10.289-21.365 14.177Z"
    />
    <Path
      fill="#75B374"
      d="m153.178 114.9-.228-.114c1.232-3.293 1.664-5.743 1.493-8.457l.248-.021c.175 2.765-.263 5.253-1.513 8.592ZM164.841 149.836c-1.323-4.356-8.545-10.821-12.426-14.295-.941-.843-1.683-1.508-2.16-1.975-2.502-2.451-4.865-6.658-4.889-6.699l.299-.126c.024.042 2.367 4.214 4.838 6.635.471.462 1.213 1.126 2.15 1.966 3.903 3.493 11.164 9.993 12.509 14.423l-.321.071Z"
    />
    <Path
      fill="#75B374"
      d="M161.512 128.477c-.053-.095-5.298-9.45-8.023-12.808-1.804-2.224-2.874-5.469-3.819-8.332-.497-1.506-.966-2.928-1.472-3.941-1.416-2.846-6.267-7.887-6.315-7.937l.166-.214c.201.207 4.929 5.121 6.366 8.007.515 1.032.988 2.465 1.487 3.982.937 2.838 1.998 6.055 3.769 8.238 2.739 3.377 7.996 12.753 8.049 12.848l-.208.157ZM176.605 134.721c-.494-.565-.711-1.392-.902-2.122-.041-.157-.08-.308-.122-.452-.34-1.19-.49-2.42-.634-3.61-.071-.589-.143-1.197-.24-1.794l.329-.039c.096.603.169 1.213.242 1.804.142 1.18.289 2.4.626 3.57.041.146.083.3.124.458.185.702.394 1.498.843 2.012l-.266.173Z"
    />
    <Path
      fill="#75B374"
      d="M156.787 120.341c-.915-.01-4.005-.152-5.31-1.547l.17-.211c.984 1.051 3.303 1.45 5.143 1.471l-.003.287ZM180.962 125.804l-.053-.284c1.266-.174 2.893-1.376 3.971-2.17l.327-.24a14.576 14.576 0 0 0 3.284-3.318l.284.15a14.922 14.922 0 0 1-3.353 3.388l-.325.239c-1.106.815-2.778 2.048-4.135 2.235Z"
    />
    <Path
      fill="#75B374"
      d="m175.396 141.393-.329-.04c.004-.024.406-2.454 1.983-6.979.931-2.67 4.434-10.301 7.523-17.033 2.179-4.751 4.064-8.854 4.55-10.148 1.162-3.084 2.755-6.71 2.77-6.747l.311.102c-.015.035-1.604 3.655-2.764 6.733-.49 1.303-2.375 5.409-4.558 10.164-3.087 6.727-6.586 14.352-7.513 17.01-1.57 4.502-1.969 6.914-1.973 6.938Z"
    />
    <Path
      fill="#75B374"
      d="M183.103 120.526c-.012-.361-.227-.8-.436-1.223a5.934 5.934 0 0 1-.338-.775c-.302-.929-.463-1.703-.51-2.436-.077-1.206-.069-2.44-.061-3.634.002-.37.004-.738.004-1.108h.332c0 .37-.002.74-.004 1.11-.007 1.189-.015 2.419.062 3.616.045.712.204 1.466.498 2.374.073.228.195.476.325.74.218.449.446.912.46 1.327l-.332.009Z"
    />
    <Path
      fill="#E39D21"
      d="M184.294 165.495c0 2.272-.241 4.97-.644 7.817-.069.48-.142.968-.219 1.459-1.421 8.99-4.314 19.011-6.446 21.928H166.81c-2.178-2.981-5.151-13.386-6.539-22.519a88.92 88.92 0 0 1-.429-3.249c-.219-1.965-.343-3.809-.343-5.438h24.795v.002Z"
    />
    <Path
      fill={yellow200}
      d="M183.473 172.914c-.097-.273-.16-.98-.213-1.605-.136-1.597-.25-2.585-.823-2.889-.155-.08-.47-.163-.843.175-.372.34-.458 1.081-.604 2.592-.077.793-.213 2.224-.431 2.605-.059-.048-.17-.158-.335-.397-.057-.187-.11-.84-.146-1.316-.143-1.796-.281-3-.923-3.357-.169-.091-.512-.195-.929.164-.422.356-.463 1.137-.512 2.124-.04.836-.101 1.975-.435 2.296-.058.056-.156.123-.392.075-.176-.147-.209-1.248-.227-1.776-.029-1.025-.057-1.913-.488-2.373a.775.775 0 0 0-.667-.257c-.881.088-1.04 1.372-1.196 2.613-.082.655-.222 1.756-.468 1.935-.053.036-.156.004-.209-.02-.14-.136-.183-1.004-.207-1.473-.059-1.209-.141-2.87-1.388-2.945-1.165-.064-1.252 1.463-1.309 2.481-.069 1.3-.164 1.636-.465 1.62-.429-.02-.531-.991-.61-2.164-.079-1.149-.154-2.228-.91-2.393-1.272-.273-1.597 1.593-1.833 2.957-.1.555-.26 1.483-.425 1.668-.106.012-.142-.024-.164-.04-.271-.249-.381-1.348-.454-2.072-.117-1.189-.219-2.217-.89-2.469a.774.774 0 0 0-.756.103c-.518.392-.634 1.34-.774 2.441-.067.536-.227 1.792-.435 1.892a.375.375 0 0 1-.089.016l-.016-.004c-.165-.132-.226-1.153-.256-1.645-.076-1.272-.173-2.857-1.321-2.913h-.067c-1.039 0-1.321 1.165-1.417 2.361a83.1 83.1 0 0 0 .429 3.25l.281.111c.176-.637.203-1.457.233-2.251.049-1.534.136-2.268.492-2.268h.014c.256.012.323 1.133.362 1.8.067 1.057.126 2.056.668 2.528.175.156.484.317.933.179.85-.256 1.016-1.588 1.179-2.877.053-.448.142-1.144.252-1.463.091.309.154.94.193 1.348.116 1.149.233 2.331.843 2.889.262.239.589.332.939.265.797-.154 1.002-1.344 1.223-2.605.126-.728.333-1.915.62-2.016.083.24.126.872.156 1.304.092 1.352.218 3.207 1.567 3.269 1.331.064 1.435-1.625 1.498-2.742.024-.404.069-1.252.203-1.356.004 0 .024-.004.059-.004.325.02.392.801.441 1.816.057 1.087.112 2.208.862 2.529.495.213.851.071 1.06-.08.651-.468.797-1.644.939-2.783.059-.46.15-1.181.27-1.488.072.317.09.956.102 1.368.039 1.276.083 2.72 1.059 2.917.465.092.861-.016 1.176-.32.681-.655.75-1.989.811-3.164.016-.345.039-.824.087-1.097.155.488.242 1.616.289 2.204.087 1.085.136 1.621.345 1.927.179.273.734 1.101 1.401.864.827-.288.977-1.851 1.15-3.659.038-.385.087-.888.144-1.277.067.425.112.984.15 1.384.069.817.13 1.519.289 1.961.219.604.522 1.076.87 1.38.077-.492.15-.979.219-1.459a2.443 2.443 0 0 1-.181-.394Z"
    />
    <Path
      fill={white}
      d="M95.956 95.997a8.289 8.289 0 1 1 0-16.577 8.289 8.289 0 0 1 0 16.577Z"
    />
    <Path
      fill={purple600}
      d="M123.671 100.329h-25.12c-.984 0-1.836.681-2.055 1.642l-9.624 42.59a6.147 6.147 0 0 1-5.995 4.792h-9.02a6.765 6.765 0 0 0-6.643 5.488h44.588a5.294 5.294 0 0 0 5.198-4.295l.23-1.193 10.499-46.452a2.11 2.11 0 0 0-2.058-2.572Z"
    />
    <Path
      fill={purple600}
      d="M116.282 196.698a.296.296 0 0 1-.293-.263l-4.491-42.07a.295.295 0 1 1 .586-.063l4.491 42.07a.296.296 0 0 1-.261.325l-.032.001ZM92.454 196.698a.297.297 0 0 1-.293-.263l-4.492-42.07a.296.296 0 0 1 .587-.063l4.491 42.07a.296.296 0 0 1-.261.325l-.032.001Z"
    />
    <Path
      fill={blue600}
      d="M57.527 122.278H27.974a.777.777 0 0 1-.762-.624l-6.04-25.111a.777.777 0 0 1 .761-.93h29.554c.37 0 .689.262.762.624l6.04 25.112a.777.777 0 0 1-.762.929Z"
    />
    <Path
      fill={blue200}
      d="M39.689 117.312c-2.528 0-4.942-2.201-5.466-5.054-.283-1.56.042-3.099.89-4.222.703-.929 1.713-1.502 2.847-1.612 2.566-.26 5.137 1.981 5.73 4.991.323 1.622.012 3.203-.85 4.338a3.891 3.891 0 0 1-3.151 1.559Zm-1.323-10.575c-.124 0-.25.006-.374.02-1.04.1-1.965.628-2.611 1.48-.791 1.048-1.093 2.491-.827 3.96.496 2.697 2.76 4.778 5.131 4.778a3.56 3.56 0 0 0 2.884-1.427c.806-1.057 1.093-2.54.788-4.068-.528-2.697-2.719-4.743-4.991-4.743Z"
    />
    <Path
      fill={blue200}
      d="m57.336 122.319-6.04-25.112a.608.608 0 0 0-.593-.492H21.149v-.347h29.554c.45 0 .843.321.931.764l6.039 25.106-.337.081Z"
    />
    <Path
      fill={blue600}
      d="M42.075 129.129h-5.003l4.184-17.714H35.98l-4.51 19.095h11.986a1.38 1.38 0 0 0-1.38-1.381Z"
    />
    <Path
      fill={blue200}
      d="M41.27 111.405a.422.422 0 0 0-.335-.162H35.98a.172.172 0 0 0-.173.173c0 .097.077.174.173.174h4.954c.034 0 .055.019.063.031.01.012.024.036.016.069l-4.129 17.484h.356l4.112-17.405c.03-.128 0-.26-.081-.364Z"
    />
    <Path
      fill={white}
      d="M106.329 127.758H87.353a.173.173 0 0 1-.174-.174c0-.096.077-.173.174-.173h18.976c.097 0 .173.077.173.173a.175.175 0 0 1-.173.174ZM51.672 196.163H57.8a1.951 1.951 0 0 0 1.11-1.455c.107-.644 3.353-5.503 3.649-6.09.882-1.76-.008-2.67.063-3.725.287-4.328 7.606-22.208 7.606-22.208l-12.142-.949s-.765 15.935-1.91 20.784c-.92 3.887-1.8 6.594-2.607 8.504-.589 1.392-1.946 3.593-1.9 4.149.027.299-.075.744.002.99ZM75.805 184.192c.9-5.045 6.78-19.345 6.78-19.345l-10.5-2.589s-1.738 17.555-3.163 22.073c-1.438 4.554-2.454 8.355-3.377 9.426-.937 1.088-1.311 1.51-1.172 2.152a.554.554 0 0 0 .13.252h7.014c1.153-.796 4.89-7.679 4.65-8.542-.26-.941-.693-1.571-.362-3.427Z"
    />
    <Path
      fill="#07060B"
      d="M51.605 196.163h7.448c.786 0 1.485-.495 1.745-1.235l.502-1.421-.099 2.658H62.7c.039-1.125.456-7.829.476-8.207.08-1.638-.374-1.998-.58-2.687 0 0-.345 2.862-2.037 5.763-.515.886-1.797 1.596-2.821 1.596h-3.17c-1.35-.169-.833-1.923-.833-1.923-.575 1.047-1.016 1.813-1.667 2.362-.475.402-.749.845-.894 1.264a4 4 0 0 0-.213 1.186.638.638 0 0 0 .644.644ZM76.167 187.621c-.085-.579-.234-1.266-.46-1.776 0 0-.627 2.935-1.92 5.607-.343.707-1.119 1.097-1.904 1.097l-5.6-.073c-.128.087-.941.61-1.103.693-1.297.656-1.917 2.123-1.762 2.766v.002c.034.138.168.227.307.227h8.849c.744 0 1.407-.475 1.648-1.18l.588-1.736.081 2.916h1.33c.001-2.195.287-6.19-.054-8.543ZM89.965 75.936c2.244-.175 3.117.048 6.127-.189 2.666-.208 5.686.197 7.718 1.936 2.032 1.738 3.03 5.095 2.132 7.614-.474 1.333-.685 2.014-.482 3.414.327 2.252 4.702 1.734 4.97 5.117.09 1.152-.237 1.6-.286 2.754-.12 2.82 3.314 1.59 4.529 5.618.732 2.427.051 5.202-2.924 7.456-5.517 4.182-15.261 1.41-19.896-.185-4.074-9.063 6.948-17.468 1.061-22.928-4.196-3.89-3.075-6.913-3.823-7.15-1.574-.493-.684-3.335.874-3.457Z"
    />
    <Path
      fill="#F33"
      d="M87.709 98.015c-6.848.82-6.56 5.29-8.935 11.093-1.73 4.233-2.567 6.527-4.334 10.541-2.894 4.038 1.054 10.471 5.545 8.031 4.08-2.219 5.478-8.984 8.108-14.898l-.384-14.767ZM105.219 99.085c2.884.949 4.833 1.703 6.318 3.833 4.016 5.769 7.704 16.656 9.078 21.332 1.058 3.593-.588 5.832-2.193 6.099-1.768.296-4.763.107-5.137-.374-1.998-6.099-5.767-12.701-7.397-18.309-.002-.002-.669-12.581-.669-12.581Z"
    />
    <Path
      fill="#07060B"
      d="M109.099 136.568c-1.13-4.062-2.29-6.165-2.878-11.66l-.026-1.036-19.033.628-.005 1.278c-.001.421-.005 1.996-.332 2.91-.546 1.518-1.473 3.235-2.266 4.664-6.037 1.038-16.762 4.316-20.548 7.719-2.453 2.203-3.53 5.625-4.353 10.014-1.904 10.147-2.715 19.425-4.765 28.953h11.725c1.069-4.198 2.34-8.764 3.62-13.336-.702 4.934-1.391 9.699-2.197 13.336h12.4c2.62-8.388 4.834-20.101 7.024-26.89 2.427-.12 14.859-1.044 19.012-2.04 4.241-1.014 4.985-6.044 2.622-14.54Z"
    />
    <Path
      fill="#153E1D"
      d="M68.032 180.212a.213.213 0 0 1-.036-.004.171.171 0 0 1-.124-.205c.786-3.721 1.445-8.575 2.144-13.714 1.363-10.01 2.77-20.36 5.3-23.552 1.525-1.921 4.726-3.611 9.263-4.887 3.945-1.108 8.7-1.85 13.39-2.089.085-.008.167.069.171.164a.168.168 0 0 1-.155.179c-8.524.433-19.175 2.762-22.416 6.852-2.471 3.117-3.873 13.42-5.228 23.383-.699 5.144-1.36 10.004-2.148 13.739a.169.169 0 0 1-.161.134Z"
    />
    <Path
      fill="#F33"
      d="m106.313 129.029 1.861-25.015.403-1.22A2.293 2.293 0 0 0 107.39 100a35.7 35.7 0 0 0-4.639-1.8c-1.484-.465-3.067-.532-5.068-1.305-.752-.292-1.63-.19-2.488-.213-3.06-.087-5.834 1.18-8.46 1.473-1.804.604-2.988 1.163-2.988 1.163s-1.22 3.588-1.37 7.252c-.096 2.333-.157 3.658.11 5.588.115.821.02 1.762 1.095 3.725.465.848.937 3.678 1.185 4.999.798 4.253 1.625 8.49 1.625 8.49l19.921-.343Z"
    />
    <Path
      fill="#138041"
      d="M80.538 119.126a.169.169 0 0 1-.132-.061c-.66-.774-1.425-1.506-2.311-2.355a96.422 96.422 0 0 1-1.603-1.559.173.173 0 0 1 0-.244.173.173 0 0 1 .244 0 96.652 96.652 0 0 0 1.597 1.553c.894.855 1.666 1.595 2.335 2.381a.174.174 0 0 1-.02.244.166.166 0 0 1-.11.041Z"
    />
    <Path
      fill={red600}
      d="M84.54 120.684a.176.176 0 0 1-.172-.146l-.68-4.097c-1.86-3.385-1.697-5.61-1.47-8.685l.037-.516a.174.174 0 0 1 .185-.16.173.173 0 0 1 .16.186l-.038.515c-.23 3.139-.384 5.21 1.444 8.52.01.018.015.035.02.055l.682 4.127a.173.173 0 0 1-.141.199c-.008.002-.018.002-.028.002Z"
    />
    <Path
      fill="#138041"
      d="M107.373 116.092h-.014a.174.174 0 0 1-.16-.185l.776-9.969a.175.175 0 0 1 .185-.159c.095.008.168.09.16.185l-.776 9.968a.172.172 0 0 1-.171.16Z"
    />
    <Path
      fill="#153E1D"
      d="M87.465 153.323a.173.173 0 0 1-.167-.219l1.08-4.026a.174.174 0 0 1 .213-.122c.093.025.148.12.122.212l-1.08 4.027a.174.174 0 0 1-.168.128ZM87.36 137.309a.17.17 0 0 1-.14-.07l-1.697-2.302a.171.171 0 0 1 .038-.242.173.173 0 0 1 .242.037l1.697 2.302a.171.171 0 0 1-.037.242.165.165 0 0 1-.103.033Z"
    />
    <Path
      fill={white}
      d="M90.647 88.234c.017-.002-1.647-.742-1.627-.748.522-.123.54-3.631.567-4.166.114-2.195 1.058-1.51 2.264-1.51.218 2.812 1.403 5.47 2.847 6.567.653-1.125 2.807-1.122 2.904.567.05.87-.434 1.654-1.12 2.15-.12 1.02-.019 2.037.205 2.969a3.857 3.857 0 0 0 2.879 2.856c.762.177 1.435.535 2.055.742-1.858 6.634-11.406 6.006-13.309-.233 1.297-.429 3.151-.803 4.473-1.249-.038-.221-.043-.223-.088-.445a12.96 12.96 0 0 1-.171-1.368c-1.096.045.499-.417 0-1.177-.53-.81-.599-.94-.599-3.03 0-.334-1.628-.37-1.781-.668-.36-.715-.46-1.11.501-1.257Z"
    />
    <Path
      fill={red600}
      d="m108.148 105.949-.155.538-.685 9.195c.708 1.76 1.522 3.575 2.345 5.41l.275.085-1.78-15.228ZM84.766 120.883c-.249-1.319-.72-4.151-1.186-4.999-.628-1.144-.856-1.939-.96-2.57l.612 10.967c.575-.957 1.087-2.037 1.573-3.189a6.455 6.455 0 0 0-.04-.209Z"
    />
    <Path fill={blue600} d="M152.321 130.383H19.371v2.111h132.95v-2.111Z" />
    <Path
      fill={blue600}
      d="M27.611 196.319a.295.295 0 0 1-.291-.349l12.178-65.435 10.719 65.124a.296.296 0 0 1-.243.339.296.296 0 0 1-.338-.242l-10.172-61.813-11.563 62.134a.295.295 0 0 1-.29.242ZM124.475 196.319a.296.296 0 0 1-.292-.349l12.178-65.435 10.719 65.124a.296.296 0 0 1-.242.339.297.297 0 0 1-.339-.242l-10.173-61.811-11.562 62.132a.294.294 0 0 1-.289.242Z"
    />
    <Path
      fill={white}
      d="M106.376 138.137c-3.176.819-6.436-1.104-7.255-4.278-.026-.097.023-.179.12-.205a.16.16 0 0 1 .205.12 5.612 5.612 0 0 0 6.848 4.039c.096-.026.179.023.204.12.024.098-.057.189-.122.204ZM106.579 125.477c-2.323.342-3.932 1.161-4.649 1.466-2.042.869-4.918.497-6.65 2.265-.37.378-.36 1.244-.357 1.244l12.721-.091c1.993.083 2.459-.326 2.566-3.075l-3.631-1.809Z"
    />
    <Path
      fill="#1B1C1C"
      d="M94.053 106.525c2.715 0 5.402-1.022 7.446-3.095.087-.087.087-.205 0-.291-.086-.089-.205-.089-.291 0-3.942 3.941-10.396 3.941-14.338 0-.087-.089-.205-.089-.291 0-.087.086-.087.204 0 .291a10.664 10.664 0 0 0 7.474 3.095Z"
    />
    <Path
      fill="#F33"
      d="M105.776 125.304c3.79-.689 7.94-3.81 11.734-2.666 2.458.741 3.397 5.377 1.003 6.754-2.942 1.691-7.106 1.23-10.394.992l-2.343-5.08Z"
    />
    <Path
      fill="#138041"
      d="M110.586 123.762a.173.173 0 0 1-.071-.331 14.308 14.308 0 0 1 2.601-.833c1.949-.421 3.465-.285 4.505.41a.173.173 0 0 1-.193.287c-2.302-1.534-6.726.431-6.771.453a.18.18 0 0 1-.071.014Z"
    />
    <Path
      fill="#1B1C1C"
      d="m109.015 129.77.051-.037 1.419-.331c.095-.027.18.034.211.132.034.099-.023.181-.12.209l-1.42.331c-.094.027-.179-.034-.21-.132.006-.044.018-.134.069-.172ZM107.516 125.507c.026-.018.026-.018.051-.038l1.42-.331c.094-.027.179.034.211.132.033.099-.024.182-.12.209l-1.42.331c-.095.027-.179-.034-.211-.132.006-.043.018-.134.069-.171ZM108.046 126.973c.026-.017.026-.017.051-.037l1.42-.331c.094-.027.179.034.21.132.034.099-.023.181-.12.209l-1.419.331c-.097.027-.179-.034-.211-.132a.17.17 0 0 1 .069-.172ZM108.518 128.34l.052-.038 1.419-.331c.095-.027.179.034.211.132.033.099-.024.182-.12.209l-1.42.331c-.094.027-.179-.034-.21-.132a.168.168 0 0 1 .068-.171Z"
    />
    <Path
      fill={white}
      d="M69.081 108.031c.656 1.065.614 1.762.614 1.762 1.022.41 1.432 1.597.983 2.581l-.327.697a1.891 1.891 0 0 1-2.455.902l-.042-.041s-2.862-.368-5.89-2.131c-3.887-2.293-4.624-5.203-3.805-6.349.778-1.107 5.482 1.392 7.242 2.294l-1.105-1.843c-.122-.247-.122-.534.042-.739.205-.205.532-.287.778-.122l2.045 1.107c.733.488 1.43 1.102 1.92 1.882Z"
    />
    <Path
      fill="#F33"
      d="M66.877 114.638c1.58-1.13 3.493-2.538 4.781-4.192 2.888 3.265 10.951 8.043 10.754 13.056-.163 4.178-4.392 6.076-7.486 3.448-3.217-2.733-5.778-8.146-8.049-12.312Z"
    />
    <Path
      fill="#1B1C1C"
      d="m68.64 115.027.053.032.862 1.177c.063.077.04.177-.039.246s-.175.05-.238-.027l-.863-1.178c-.063-.076-.039-.177.04-.246.043-.012.132-.037.185-.004ZM71.973 111.978l.054.031.862 1.178c.063.076.04.177-.04.246-.078.069-.175.049-.238-.028l-.862-1.177c-.063-.077-.04-.178.04-.246.045-.012.131-.036.184-.004ZM70.833 113.039l.053.031.863 1.178c.063.076.04.177-.04.246-.078.069-.175.049-.238-.028l-.862-1.177c-.063-.077-.04-.177.04-.246a.165.165 0 0 1 .184-.004ZM69.76 114.011c.028.015.028.015.053.031l.863 1.178c.063.076.04.177-.04.246-.078.069-.175.049-.238-.028l-.862-1.177c-.063-.077-.04-.177.04-.246a.168.168 0 0 1 .184-.004Z"
    />
  </>
);

export const JobPostingIllustration = createIllustration({
  viewBox: '0 0 204 197',
  vectorComponent
});
